import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=48eb9a7a&scoped=true&"
import script from "./Benefit.vue?vue&type=script&lang=js&"
export * from "./Benefit.vue?vue&type=script&lang=js&"
import style0 from "./Benefit.vue?vue&type=style&index=0&id=48eb9a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb9a7a",
  null
  
)

export default component.exports